import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';

@Component({
    selector: 'companyid-divider-img',
    imports: [NgOptimizedImage, AssetPipe],
    templateUrl: './divider-img.component.html',
    styleUrl: './divider-img.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DividerImgComponent {
    public dividerImages = [
        {
            imgName: 'divider',
            width: 1728,
            height: 45,
            classNames: 'w-screen tab:hidden mob:hidden',
        },
        {
            imgName: 'divider-tab',
            width: 744,
            height: 44,
            classNames: 'w-screen desk:hidden mob:hidden',
        },
        {
            imgName: 'divider-mob',
            width: 393,
            height: 45,
            classNames: 'w-screen desk:hidden tab:hidden',
        },
    ];
}
